/**
 * Check whether the URL search string contains comment highlighting parameters from notifications.
 *
 * @param search - The URL search string to check
 * @returns True if redirecting from notifications with comment parameters
 */
export const isRedirectingFromNotifications = (search: string): boolean => {
  const searchParams = new URLSearchParams(search);
  return (
    searchParams.has("showTlfItemComments") ||
    searchParams.has("commentId") ||
    searchParams.has("showHierarchyComments")
  );
};
